import { IBaseIconProps } from "./IBaseIconProps";

/** A small pennant on a pole: a mark staff put on a client. */
export const FlagIcon = ({ color = "currentColor" }: IBaseIconProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 21V4" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
      <path
        d="M5 4.5H17.5L15 8.75L17.5 13H5"
        stroke={color}
        strokeWidth="1.6"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
